import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "pt-5",
  key: "spacer"
}, null, -1)
const _hoisted_4 = { class: "button-container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_FamilyMemberComponent = _resolveComponent("FamilyMemberComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.cms.useAdultAccident)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", {
            key: "personCountLabel",
            class: "input__label",
            textContent: _toDisplayString(_ctx.personCountLabel)
          }, null, 8, _hoisted_2),
          _createVNode(_component_SelectModalComponent, {
            key: "personCount",
            id: "personCount",
            name: "personCount",
            preSelect: this.model.familyInfo.personCount,
            innerData: _ctx.personCountList,
            selected: _ctx.model.familyInfo.personCount !== undefined,
            placeholder: "Vælg hvor mange børn der skal forsikres",
            visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
            errorMsgOverride: "Du skal vælge hvor mange børn der skal forsikres",
            "onSelectModalComponent:selected": _ctx.familyMemberCountSelected
          }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"]),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.familyInfo.personCountId + 1, (inx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'ch' + inx
      }, [
        (_openBlock(), _createBlock(_component_FamilyMemberComponent, {
          key: 'cc' + (inx - 1),
          personNo: inx - 1,
          placeholderName: "F.eks. Lisa Sofie Jensen",
          labelName: _ctx.getPersonNameLabel(inx - 1),
          placeholderAge: "",
          labelAge: _ctx.getPersonAgeLabel(inx - 1),
          placeholderWork: "Indtast f.eks Maskintekniker...",
          labelWork: _ctx.getLabelWork(inx - 1),
          labelQuestionWork: _ctx.cms.workForMinorsLabel,
          card: _ctx.card
        }, null, 8, ["personNo", "labelName", "labelAge", "labelWork", "labelQuestionWork", "card"]))
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ButtonTapComponent, {
        class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
        textContent: _toDisplayString(_ctx.card.linkText),
        "data-gtm": _ctx.cms.dataGtm,
        "data-gtm-click-text": _ctx.card.routePath
      }, null, 8, ["class", "textContent", "data-gtm", "data-gtm-click-text"])
    ])
  ]))
}